/**
 * Geometry of the compact table rows and header, in theme spacing steps. Shared by the header,
 * the rows and `getCompactTableMinWidth`, so the width the compact table needs always matches
 * what it renders.
 */
export const COMPACT_TABLE_GEOMETRY = {
  horizontalPadding: 3,
  checkboxColumnWidth: 14,
  columnSpacing: 2,
  /** Columns without a configured width grow, but never below this. */
  flexibleColumnMinWidth: 65,
  trailingSpaceWidth: 6,
} as const;
